export const INIT_SDK = 'INIT_SDK';
export const SET_SDK_LOADING = 'SET_SDK_LOADING';
export const RESET_SDK = 'RESET_SDK';
export const SDK_ERROR = 'SDK_ERROR';
